export class Sort {
  static sortHandleNull(a, b) {
    let aEmpt = a === null || a === undefined
    let bEmpt = b === null || b === undefined
    if (aEmpt && bEmpt) return 0

    return bEmpt - aEmpt || a - b
  }
}
